export default "__VITE_ASSET__DaQxffnj__"